"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_toolbar_options_html_1 = __importDefault(require("./widget-toolbar-options.html"));
require("./widget-toolbar-options.less");
(function (module) {
    WidgetToolbarOptionsController.$inject = [
        'prTextEditorMenu'
    ];
    function WidgetToolbarOptionsController(prTextEditorMenu) {
        var $ctrl = this;
        $ctrl.toolbarOptions = prTextEditorMenu.getTextEditorMenu();
    }
    module.component('prWidgetToolbarOptions', {
        templateUrl: widget_toolbar_options_html_1.default,
        controller: WidgetToolbarOptionsController
    });
})(angular.module('qualtrics.pr'));
